import getter from '../getter';
export default function getEntityDefaultListComponent(entity) {
    const getterName = 'defaultListComponent';
    const result = getter(entity, getterName);
    return result;
}
